<template>
	<v-card dark>
		<v-card-title class="title">{{ node.name }}</v-card-title>
		<v-card-subtitle class="subtitle">{{ meta.description }}</v-card-subtitle>
		<v-simple-table class="info-table">
			<tr v-clip="guid">
				<td class="label">guid</td>
				<td class="value">{{ guid }}</td>
				<td><misc-copy-icon /></td>
			</tr>

			<tr v-clip="node.path">
				<td class="label">path</td>
				<td class="value">{{ node.path }}</td>
				<td><misc-copy-icon /></td>
			</tr>

			<tr v-clip="meta.cls">
				<td class="label">class</td>
				<td class="value">{{ meta.cls }}</td>
				<td><misc-copy-icon /></td>
			</tr>

			<tr v-clip="meta.group">
				<td class="label">group</td>
				<td class="value">{{ meta.group }}</td>
				<td><misc-copy-icon /></td>
			</tr>
		</v-simple-table>
	</v-card>
</template>

<style lang="scss" scoped>
.title {
	color: var(--v-accent-base);
}

.subtitle {
	text-align: left;
}

.info-table {
	tr > td {
		text-align: left;

		&.label {
			color: var(--v-accent-base);
			text-transform: uppercase;
			font-weight: bold;
		}

		&.value {
			font-size: 80%;
		}
	}
}
</style>

<script>
import { mapGetters } from "vuex";

export default {
	props: ["guid"],

	computed: {
		...mapGetters({
			nodeByGuid: "controller/nodes/nodeByGuid",
		}),

		node() {
			return this.nodeByGuid(this.guid);
		},

		meta() {
			return this.node.meta;
		},
	},
};
</script>
